/**
 * Parametry elektryczne wpisane ręcznie przez użytkownika.
 *
 * DLACZEGO TO W OGÓLE ISTNIEJE: komplet danych elektrycznych ma ok. 12% modułów
 * i 20% falowników w katalogu. Ręczne przepisanie ich z karty katalogowej to
 * ścieżka GŁÓWNA, nie awaryjna. Bez zapamiętania user musiałby wpisywać te same
 * siedem liczb trzy razy — w asystencie, na potwierdzeniu zestawu i przy wyborze
 * wykonawcy.
 *
 * Klucz to `strona:model_id`, a nie sam numer kroku — dzięki temu podmiana
 * falownika na ekranie potwierdzenia NIE podstawia po cichu parametrów starego.
 *
 * sessionStorage, nie localStorage: dane z karty katalogowej dotyczą konkretnego
 * doboru, a nie preferencji użytkownika. Po zamknięciu karty nie ma powodu ich
 * trzymać.
 */

import { kluczKraju } from '../kraj'

const KLUCZ = kluczKraju('vv:parametry-elektryczne')

const wczytajWszystko = () => {
  try {
    return JSON.parse(sessionStorage.getItem(KLUCZ)) || {}
  } catch {
    return {}
  }
}

/**
 * @param {Object} wpisane  mapa `"panel.voc_v" -> "49.85"` prosto z formularza
 * @param {Object} idki     `{ panel: <model_id>, inverter: <model_id> }`
 */
export const zapiszParametry = (wpisane, idki) => {
  const wszystko = wczytajWszystko()
  Object.entries(wpisane || {}).forEach(([klucz, wartosc]) => {
    if (wartosc === '' || wartosc == null) return
    const [strona, pole] = klucz.split('.')
    const id = idki?.[strona]
    if (!id) return
    const podKlucz = `${strona}:${id}`
    wszystko[podKlucz] = { ...(wszystko[podKlucz] || {}), [pole]: Number(wartosc) }
  })
  try {
    sessionStorage.setItem(KLUCZ, JSON.stringify(wszystko))
  } catch {
    // Prywatne okno albo pełny magazyn — schemat ma działać dalej, tylko bez pamięci.
  }
}

/** Zwraca `{ panel: {...}, inverter: {...} }` gotowe do wysłania do API. */
export const odczytajParametry = (idki) => ({
  panel: (idki?.panel && wczytajWszystko()[`panel:${idki.panel}`]) || {},
  inverter: (idki?.inverter && wczytajWszystko()[`inverter:${idki.inverter}`]) || {},
})

/** Te same dane w formacie formularza (`"panel.voc_v" -> "49.85"`). */
export const odczytajJakoFormularz = (idki) => {
  const z = odczytajParametry(idki)
  const wynik = {}
  Object.entries(z).forEach(([strona, pola]) => {
    Object.entries(pola).forEach(([pole, wartosc]) => {
      wynik[`${strona}.${pole}`] = String(wartosc)
    })
  })
  return wynik
}
